/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Button from "../../atoms/button/button";
import "./FormBottomAceleradoraTwo.scss";
import ArrowRigth from "../../atoms/icons/ArrowRigth";

interface IBottomFormAceleradoraTwoProps {
    flagGTM: string;
    titleButton: string;
    activeStep: number;
    disableNextBtn?: boolean;
    onClicPrevBtn?: () => void;
    onClickNextBtn?: () => void;
    onClickCancel?: () => void;
}

const componentMainClassName = `m-form-bottom-aceleradora-two`;

const FormBottomAceleradoraTwo = ({
    flagGTM,
    titleButton,
    activeStep,
    disableNextBtn = false,
    onClicPrevBtn,
    onClickNextBtn,
    onClickCancel
}: IBottomFormAceleradoraTwoProps) => {

    return (
        <div className={`${componentMainClassName}`}>
            <Button
                type="link"
                self
                classname={`${componentMainClassName}__cancelar`}
                text="Cancelar"
                isDisabled={false}
                onClickAction={onClickCancel}
            ></Button>
            <div className={`${componentMainClassName}__navigation`}>
                {activeStep > 0 ? (
                    <Button
                        type="button"
                        classname={`a-button__magenta-modal-aceleradora  ${componentMainClassName}__back `}
                        text={"Volver"}
                        isDisabled={false}
                        onClickAction={onClicPrevBtn}
                    >
                        <ArrowRigth />
                    </Button>
                ) : null}

                <Button
                    type="button"
                    classname={`a-button__magenta_aceleradora  ${componentMainClassName}__next  gtm${flagGTM}`}
                    text={titleButton}
                    isDisabled={disableNextBtn}
                    onClickAction={onClickNextBtn}
                >
                    <ArrowRigth />
                </Button>
            </div>
        </div>
    );
};

export default FormBottomAceleradoraTwo;
